import { render, staticRenderFns } from "./M60SInfrared.vue?vue&type=template&id=76c8b62c&scoped=true&"
import script from "./M60SInfrared.vue?vue&type=script&lang=js&"
export * from "./M60SInfrared.vue?vue&type=script&lang=js&"
import style0 from "./M60SInfrared.vue?vue&type=style&index=0&id=76c8b62c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c8b62c",
  null
  
)

export default component.exports